import { RootState } from 'store';

const AddressesLookupState = (state: RootState) => state.lookups.addressLookup;

export const selectAddressLookupResults = (state: RootState) => AddressesLookupState(state).rows;
export const selectAddressComponents = (state: RootState) => AddressesLookupState(state).row;
export const selectAddressFields = (state: RootState) => AddressesLookupState(state).addressFields;
